<template>
  <v-container fluid class="py-0 px-0">
    <v-card tile>
      <v-card-title>
        Data Customer
        <v-spacer></v-spacer>
        <v-select
          v-model="tipeFilter"
          :items="tipeFilterItems"
          label="Filter tipe"
          dense
          hide-details
          clearable
          item-text="text"
          item-value="value"
          class="mr-3 pt-0 mt-0"
          style="max-width: 200px;"
        ></v-select>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Cari customer..."
          single-line
          hide-details
          dense
        ></v-text-field>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="customers"
        :loading="loading"
        :server-items-length="totalCustomers"
        :options.sync="tableOptions"
        :footer-props="{ itemsPerPageOptions: [10, 15, 25, 50] }"
        :disable-sort="true"
        dense
        class="elevation-1"
        @click:row="openDetail"
        style="cursor: pointer"
      >
        <template v-slot:item.tipe="{ item }">
          <v-chip
            x-small
            :color="item.tipe === 'Pengirim' ? 'blue' : 'green'"
            dark
          >
            {{ item.tipe }}
          </v-chip>
        </template>
      </v-data-table>
    </v-card>

    <!-- Detail Dialog -->
    <v-dialog v-model="dialog" max-width="1100px" scrollable>
      <v-card v-if="selected">
        <v-card-title class="pb-1">
          {{ selected.nama }}
          <span class="ml-2 text-caption grey--text">{{
            selected.badan_usaha
          }}</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>

        <v-card-subtitle class="pt-0">
          {{ selected.alamat }} &nbsp;&bull;&nbsp;
          {{ selected.telp }} &nbsp;&bull;&nbsp; {{ selected.kota }}
        </v-card-subtitle>

        <v-divider></v-divider>

        <v-card-text class="pa-0">
          <v-tabs v-model="tab" dense>
            <v-tab>
              <v-icon left small>mdi-truck</v-icon>
              Pengiriman
              <v-chip x-small class="ml-1">{{
                detail.pengiriman.length
              }}</v-chip>
            </v-tab>
            <v-tab>
              <v-icon left small>mdi-receipt</v-icon>
              Invoice
              <v-chip x-small class="ml-1">{{ detail.invoice.length }}</v-chip>
            </v-tab>
            <v-tab>
              <v-icon left small>mdi-cash-clock</v-icon>
              Piutang
              <v-chip x-small color="orange" dark class="ml-1">{{
                detail.piutang.length
              }}</v-chip>
            </v-tab>
            <v-tab>
              <v-icon left small>mdi-cash-check</v-icon>
              Pelunasan
              <v-chip x-small color="green" dark class="ml-1">{{
                detail.pelunasan.length
              }}</v-chip>
            </v-tab>
          </v-tabs>

          <v-progress-linear
            v-if="detailLoading"
            indeterminate
            color="primary"
          ></v-progress-linear>

          <v-tabs-items v-model="tab">
            <!-- Tab: Pengiriman -->
            <v-tab-item>
              <v-data-table
                :headers="pengirimanHeaders"
                :items="detail.pengiriman"
                dense
                :items-per-page="10"
                class="elevation-0"
                no-data-text="Tidak ada data pengiriman"
              >
                <template v-slot:item.tgl="{ item }">{{
                  formatYmdDash(item.tgl)
                }}</template>
                <template v-slot:item.penerima_nama="{ item }">{{
                  item.penerima_nama || dashText
                }}</template>
                <template v-slot:item.no_container="{ item }">{{
                  item.no_container || dashText
                }}</template>
                <template v-slot:item.nama_kapal="{ item }">{{
                  item.nama_kapal || dashText
                }}</template>
                <template v-slot:item.no_ttpb="{ item }">{{
                  item.no_ttpb || dashText
                }}</template>
                <template v-slot:item.tgl_terima="{ item }">{{
                  formatYmdCsv(item.tgl_terima) || dashText
                }}</template>
              </v-data-table>
            </v-tab-item>

            <!-- Tab: Invoice -->
            <v-tab-item>
              <v-data-table
                :headers="invoiceHeaders"
                :items="detail.invoice"
                dense
                :items-per-page="10"
                class="elevation-0"
                no-data-text="Tidak ada data invoice"
              >
                <template v-slot:item.total="{ item }">
                  {{ formatRupiah(item.total) }}
                </template>
                <template v-slot:item.lunas="{ item }">
                  <v-chip
                    x-small
                    :color="item.lunas === 'Y' ? 'green' : 'orange'"
                    dark
                  >
                    {{ item.lunas === "Y" ? "Lunas" : "Belum" }}
                  </v-chip>
                </template>
              </v-data-table>
            </v-tab-item>

            <!-- Tab: Piutang -->
            <v-tab-item>
              <div class="pa-3 text-right font-weight-bold orange--text">
                Total Piutang: {{ formatRupiah(totalPiutang) }}
              </div>
              <v-data-table
                :headers="piutangHeaders"
                :items="detail.piutang"
                dense
                :items-per-page="10"
                class="elevation-0"
                no-data-text="Tidak ada piutang"
              >
                <template v-slot:item.total="{ item }">
                  {{ formatRupiah(item.total) }}
                </template>
              </v-data-table>
            </v-tab-item>

            <!-- Tab: Pelunasan -->
            <v-tab-item>
              <div class="pa-3 text-right font-weight-bold green--text">
                Total Lunas: {{ formatRupiah(totalPelunasan) }}
              </div>
              <v-data-table
                :headers="pelunasanHeaders"
                :items="detail.pelunasan"
                dense
                :items-per-page="10"
                class="elevation-0"
                no-data-text="Tidak ada data pelunasan"
              >
                <template v-slot:item.total="{ item }">
                  {{ formatRupiah(item.total) }}
                </template>
              </v-data-table>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";
import debounce from "lodash/debounce";

export default {
  name: "MasterCustomer",
  data() {
    return {
      dashText: "-",
      tipeFilter: null,
      tipeFilterItems: [
        { text: "Semua", value: null },
        { text: "Pengirim", value: "pengirim" },
        { text: "Penerima", value: "penerima" }
      ],
      search: "",
      totalCustomers: 0,
      tableOptions: {
        page: 1,
        itemsPerPage: 15,
        sortBy: [],
        sortDesc: []
      },
      loading: false,
      detailLoading: false,
      dialog: false,
      tab: 0,
      selected: null,
      customers: [],
      detail: {
        pengiriman: [],
        invoice: [],
        piutang: [],
        pelunasan: []
      },
      customersFetchGeneration: 0,
      headers: [
        { text: "Nama", value: "nama" },
        { text: "Badan Usaha", value: "badan_usaha" },
        { text: "Kota", value: "kota" },
        { text: "Telp", value: "telp" },
        { text: "Alamat", value: "alamat" },
        { text: "Tipe", value: "tipe", width: 110 }
      ],
      pengirimanHeaders: [
        { text: "Tgl TTB", value: "tgl", width: 110 },
        { text: "No TTB", value: "nottb", width: 100 },
        { text: "Penerima", value: "penerima_nama" },
        { text: "No Container", value: "no_container", width: 140 },
        { text: "Nama Kapal", value: "nama_kapal", width: 160 },
        { text: "No TTPB", value: "no_ttpb", width: 100 },
        { text: "Tgl Terima Barang", value: "tgl_terima", width: 140 }
      ],
      invoiceHeaders: [
        { text: "No Nota", value: "nomor_nota" },
        { text: "Tanggal Nota", value: "tgl_nota" },
        { text: "Total", value: "total", align: "right" },
        { text: "Status", value: "lunas", align: "center" },
        { text: "Tgl Lunas", value: "tgl_lunas" }
      ],
      piutangHeaders: [
        { text: "No Nota", value: "nomor_nota" },
        { text: "Tanggal Nota", value: "tgl_nota" },
        { text: "Total", value: "total", align: "right" }
      ],
      pelunasanHeaders: [
        { text: "No Nota", value: "nomor_nota" },
        { text: "Tanggal Nota", value: "tgl_nota" },
        { text: "Total", value: "total", align: "right" },
        { text: "Tgl Lunas", value: "tgl_lunas" },
        { text: "No Pelunasan", value: "no_pelunasan" }
      ]
    };
  },
  computed: {
    totalPiutang() {
      return this.detail.piutang.reduce((s, i) => s + (i.total || 0), 0);
    },
    totalPelunasan() {
      return this.detail.pelunasan.reduce((s, i) => s + (i.total || 0), 0);
    },
    paginationKey() {
      return `${this.tableOptions.page}-${this.tableOptions.itemsPerPage}`;
    }
  },
  watch: {
    paginationKey: {
      handler() {
        this.fetchCustomers();
      },
      immediate: true
    },
    search() {
      this.debouncedFetchCustomers();
    },
    tipeFilter() {
      if (this.tableOptions.page !== 1) {
        this.tableOptions = { ...this.tableOptions, page: 1 };
      } else {
        this.fetchCustomers();
      }
    }
  },
  methods: {
    async fetchCustomers() {
      const gen = ++this.customersFetchGeneration;
      this.loading = true;
      const statusParam =
        this.tipeFilter === "pengirim" || this.tipeFilter === "penerima"
          ? this.tipeFilter
          : undefined;
      try {
        const res = await axios.get("invoice/customers", {
          params: {
            paginate: 1,
            page: this.tableOptions.page,
            per_page: this.tableOptions.itemsPerPage,
            search: this.search ? this.search : undefined,
            status: statusParam
          }
        });
        if (gen !== this.customersFetchGeneration) {
          return;
        }
        const rows = res.data.data || [];
        this.totalCustomers = (res.data.meta && res.data.meta.total) || 0;
        this.customers = rows.map(c => ({
          ...c,
          tipe: String(c.status || "").toLowerCase() === "pengirim" ? "Pengirim" : "Penerima"
        }));
      } catch (_) {
        if (gen !== this.customersFetchGeneration) {
          return;
        }
      } finally {
        if (gen === this.customersFetchGeneration) {
          this.loading = false;
        }
      }
    },
    async openDetail(item) {
      this.selected = item;
      this.tab = 0;
      this.detail = { pengiriman: [], invoice: [], piutang: [], pelunasan: [] };
      this.dialog = true;
      this.detailLoading = true;

      await axios
        .get(`customer/detail/${item.status}/${item.id}`)
        .then(res => {
          this.detail.pengiriman = res.data.pengiriman || [];
          this.detail.invoice = res.data.invoice || [];
          this.detail.piutang = res.data.piutang || [];
          this.detail.pelunasan = res.data.pelunasan || [];
        })
        .catch(() => {})
        .finally(() => {
          this.detailLoading = false;
        });
    },
    formatRupiah(val) {
      if (!val && val !== 0) return "-";
      return "Rp " + Number(val).toLocaleString("id-ID");
    },
    formatYmdDash(val) {
      if (!val) return this.dashText;
      return String(val).slice(0, 10);
    },
    formatYmdCsv(val) {
      if (!val) return "";
      return String(val)
        .split(",")
        .map(s => s.trim().slice(0, 10))
        .filter(Boolean)
        .join(", ");
    }
  },
  created() {
    this.debouncedFetchCustomers = debounce(() => {
      if (this.tableOptions.page !== 1) {
        this.tableOptions = { ...this.tableOptions, page: 1 };
      } else {
        this.fetchCustomers();
      }
    }, 400);
  },
  beforeDestroy() {
    if (this.debouncedFetchCustomers && this.debouncedFetchCustomers.cancel) {
      this.debouncedFetchCustomers.cancel();
    }
  }
};
</script>
